module.exports = __webpack_public_path__ + "assets/img/38f2bcc8eb21dd1cbe5ecad12253648b.png";